import {apiPost, API_URL} from '../api'

export const editRecommendRankApi = async (id: string, rank: number) => {
    return await apiPost(API_URL, 'admin/featured_edit', {post_id: id, rank: rank})
}
